module.exports = __webpack_public_path__ + "static/media/2016_composite.cab268d3.jpg";